import { Box, Tooltip } from '@mui/material';
import { redirectToAlyviaSSO } from 'utils';

export default function Logo() {
	return (
		<Tooltip title="Ir para o Alyvia SSO">
			<Box sx={{ cursor: 'pointer' }} onClick={redirectToAlyviaSSO}>
				<img src="/alyvia_logo.png" alt="Logo" height={40} />
			</Box>
		</Tooltip>
	)
}
